import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DeliveryServiceType as LinkDeliveryServiceType } from '../links/DeliveryServiceType';
import { type DeliveryOptions as SchemaDeliveryOptions } from '../schemas/DeliveryOptions';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const GetDeliveryOptionsContentType = '' as const;
export type GetDeliveryOptionsRequest = undefined;
export type GetDeliveryOptionsResponses = LinkCommonErrorResponses & {
    /**
     * @description Delivery options
     */
    '200': {
        'application/json': SchemaDeliveryOptions;
    };
};
export type GetDeliveryOptionsResponseSuccess = GetDeliveryOptionsResponses['200']['application/json'];
export type GetDeliveryOptionsSearchParams = {
    address?: string;
    pickup_point_id?: string;
    locality_only?: boolean;
    service_type?: LinkDeliveryServiceType;
};
export type GetDeliveryOptionsPathParameters = {
    store_slug: string;
    order_id: string;
};
export const GetDeliveryOptionsUrl = '/{store_slug}/orders/{order_id}/delivery/options' as const;
export const GetDeliveryOptionsMethod = 'GET' as const;
export const getGetDeliveryOptionsUrl = (params: GetDeliveryOptionsPathParameters) =>
    GetDeliveryOptionsUrl.replace(/\{(\w+)\}/g, (_match, param: keyof GetDeliveryOptionsPathParameters) =>
        String(params[param])
    );
